import Toast from 'Toast'

const missingTranslations = new Set<string>()

export default function translate(
  key: string,
  options: Record<string, number | string> = {}
) {
  let translatedString =
    (typeof window._T === 'object' && window._T[key]) ||
    (typeof window._GT === 'object' && window._GT[key])

  if (!translatedString) {
    if (import.meta.env.DEV && window._T?._current_path) {
      autofixMissingTranslation({
        key,
        path: window._T._current_path,
      })
      markTranslationAsMissing(key)
    }
    translatedString = key
  }

  return translatedString.replace(/\{\{(\w+)}}/g, (_str, m1) =>
    String(options[m1])
  )
}

function autofixMissingTranslation(missingTranslation: {
  key: string
  path: string
}) {
  if (window._T?._translation_autofix_enabled) {
    return
  }

  $.post('/admin/missing_translation', {
    data: missingTranslation,
    dataType: 'JSON',
  })
}

function markTranslationAsMissing(t: string) {
  missingTranslations.add(t)
  reportMissingTranslations()
}

function reportMissingTranslations() {
  let message = 'Some JS translations are missing:<br/>'

  message += Array.from(missingTranslations)
    .map((it) => `• "${it}"`)
    .join('<br/>')
  message += '<br/><br/>You can include them in ' + window._T?._current_path
  Toast.error(message, { autoHideDuration: 60000, key: 'missing-translations' })
}
